/**
 * Guard to check whether a user has a valid token session or not
 * @param {*} to where it will be redirect
 * @param {*} from which route is the user comming from
 * @param {*} next where the user'd be redirect if the token session is still valid
 */
import { encryptStorage } from '@/utils/storage.js';

const isAuthenticatedGuard = ( to, from, next) => {
    // console.log({to, from, next})
    const token = encryptStorage.getItem('token')

    // token ? next() : next({ name: 'Login'})
    if (token) {
        console.log(' --- EL USUARIO ESTÁ AUTENTICADO --- ')
        next()
    } else {
        console.log(' --- EL USUARIO NO ESTÁ AUTENTICADO --- ')
        next({ name: 'auth'})
    }
}

const isGuestGuard = ( to, from, next) => {
    const token = encryptStorage.getItem('token')

    if (token) {
        next({ name: 'pbxCloud-chat' })
    } else {
        next()
    }
}

export { isGuestGuard }
export default isAuthenticatedGuard